import React from 'react';
export function EditorAnchorLinkIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.83a3.001 3.001 0 10-2 0V10H8a1 1 0 100 2h3v7.938c-1.52-.188-2.925-.801-3.998-1.74C5.7 17.057 5 15.544 5 14a1 1 0 10-2 0c0 2.168.985 4.215 2.685 5.702C7.38 21.185 9.653 22 12 22c2.347 0 4.62-.815 6.315-2.298C20.015 18.215 21 16.168 21 14a1 1 0 10-2 0c0 1.545-.7 3.058-2.002 4.197-1.073.94-2.478 1.553-3.998 1.741V12h3a1 1 0 100-2h-3V7.83z"
  }));
}